import React, { useState } from 'react';
import { ArrowRight, Sparkles, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPrefix, selectUserType } from '../Redux/profile';
import { useProductAnnouncements } from '../productAnnouncements';

export default function ProductAnnouncementBanner() {
  const navigate = useNavigate();
  const prefix = useSelector(selectPrefix);
  const userType = useSelector(selectUserType);
  const announcements = useProductAnnouncements(prefix, userType);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem('dismissedProductAnnouncements') || '[]'); }
    catch { return []; }
  });
  const announcement = announcements.find((item) => item.showOnHome !== false && !dismissed.includes(item.id));

  if (!announcement) return null;

  const dismiss = () => {
    const next = [...new Set([...dismissed, announcement.id])];
    setDismissed(next);
    localStorage.setItem('dismissedProductAnnouncements', JSON.stringify(next));
  };

  return (
    <div
      className="mx-3 mt-3 flex items-start gap-3 rounded-xl border px-4 py-3 shadow-sm md:mx-5"
      style={{
        backgroundColor: '#FFF7ED',
        borderColor: '#FDBA74',
        color: '#1E293B',
      }}
    >
      <Sparkles size={18} className="mt-0.5 shrink-0" color="#EA580C" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold"><span className="mr-2 rounded px-2 py-0.5 text-[10px] uppercase tracking-wide text-white" style={{ backgroundColor: '#F97316' }}>New</span>{announcement.title}</p>
        <p className="mt-1 text-xs leading-5" style={{ color: '#475569' }}>{announcement.description}</p>
      </div>
      {announcement.targetPath ? (
        <button type="button" onClick={() => navigate(announcement.targetPath)} className="hidden shrink-0 items-center gap-1 rounded-lg px-3 py-2 text-xs font-bold hover:bg-orange-100 sm:flex" style={{ color: '#C2410C' }}>View feature <ArrowRight size={14} /></button>
      ) : null}
      <button type="button" onClick={dismiss} aria-label="Dismiss announcement" className="shrink-0 rounded-md p-1.5 text-slate-400 hover:bg-orange-100 hover:text-slate-700"><X size={16} /></button>
    </div>
  );
}
